export default __webpack_public_path__ + "static/media/for_sale_tag.39f66688.png";